import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown, ChevronUp, ShieldCheck } from 'lucide-react';
export function ProofAndFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Necesito ser un experto en computación?',
    a: 'No, si sabes enviar un mensaje por WhatsApp o usar Facebook, puedes seguir este método. Está diseñado específicamente para personas sin experiencia técnica.'
  }, {
    q: '¿Es seguro poner mis documentos en Internet?',
    a: 'Sí, te enseñamos a usar los servicios que ya tienes (como Apple o Google) de forma mucho más segura, sin exponer tu información a extraños.'
  }, {
    q: '¿Cuánto tiempo me tomará?',
    a: 'El sistema está diseñado para completarse en bloques de tiempo cortos que suman un total de 2 horas. Puedes hacerlo a tu propio ritmo.'
  }, {
    q: '¿Qué pasa si cambio de teléfono?',
    a: 'Tu Legado Digital está protegido en la nube; lo verás en cualquier dispositivo nuevo de inmediato con solo iniciar sesión.'
  }];
  return <section className="bg-cream py-20 px-6" data-id="element-179">
      <div className="max-w-4xl mx-auto space-y-20" data-id="element-180">
        {/* Proof Section */}
        <FadeIn data-id="element-181">
          <div className="bg-navy text-white p-10 rounded-3xl shadow-xl text-center relative overflow-hidden" data-id="element-182">
            <div className="absolute top-0 right-0 opacity-10 transform translate-x-1/4 -translate-y-1/4" data-id="element-183">
              <ShieldCheck className="w-64 h-64" data-id="element-184" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 relative z-10" data-id="element-185">
              Tu Legado, Protegido en 7 Días
            </h2>
            <p className="text-xl md:text-2xl leading-relaxed text-gray-200 relative z-10" data-id="element-186">
              Pasarás de tener un teléfono lleno de fotos desordenadas y
              documentos perdidos, a tener un Legado Digital organizado que
              podrías entregar a tu familia hoy mismo con total orgullo y
              seguridad.
            </p>
          </div>
        </FadeIn>

        {/* FAQ Section */}
        <FadeIn data-id="element-187">
          <div data-id="element-188">
            <h2 className="text-4xl font-bold text-center text-navy mb-12" data-id="element-189">
              Preguntas Frecuentes
            </h2>
            <div className="space-y-4" data-id="element-190">
              {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden transition-all duration-300" data-id="element-191">
                  <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-192">
                    <span className="text-xl font-bold text-navy pr-8" data-id="element-193">
                      {faq.q}
                    </span>
                    {openIndex === index ? <ChevronUp className="w-6 h-6 text-gold flex-shrink-0" data-id="element-194" /> : <ChevronDown className="w-6 h-6 text-gold flex-shrink-0" data-id="element-195" />}
                  </button>
                  <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-196">
                    <p className="text-lg text-gray-700 border-t border-gray-100 pt-4" data-id="element-197">
                      {faq.a}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}